// Opacity

.opacity(@opacity) {
  opacity: @opacity;
  // IE8 filter
  @opacity-ie: (@opacity * 100);
  filter: ~"alpha(opacity=@{opacity-ie})";
}



// WEBPACK FOOTER //
// webpack:///node_modules/bootstrap/less/mixins/opacity.less